export default {
  subtitle: "深入探討 CBAM 合規、碳排放計算和行業最佳實踐",
  no_posts: "暫無文章",
  loading: "載入中...",
  read_time: "{minutes} 分鐘閱讀",
  minute: "分鐘",
  share: "分享：",
  back_to_list: "返回博客列表",
  article_not_found: "找不到文章",
  article_not_found_desc: "抱歉，您查找的文章不存在",
  cta_title: "準備好開始您的 CBAM 合規之旅了嗎？",
  cta_subtitle: "立即試用 TaxEcoBit，輕鬆生成符合歐盟標準的碳排放報告",
  cta_button: "立即體驗",
};
